//brand/products relation field type
$('select[data-action="brand_products"]').change(function() {

    var select = $(this);

    var value = select.val();
    var type = $(this).data('type');

    var index = 0;
    var subselect_selector = 'select[name="'+type+'_id"]';

    if(select.data('multiple')==1){
        index = select.data('index');
        subselect_selector = 'select[name="'+type+'_id[]"][data-index="'+index+'"]';
    }

    var subselect = $(subselect_selector);

    // reset subfields
    subselect.find('option').remove().end();
    select.data('fields').split(/\s*,\s*/).forEach(function(field_name) {
        console.log(field_name);
        $(['name="'+field_name+'"']).val("");
    });
    // reset image (non multiple/inverters type)
    $('.js-'+type+'_image').prop('src','');

    var url = ajax_model_routes[type];

    var option =''
    var jqxhr = $.getJSON(url, {id:value}, function(data) {
        subselect.append($('<option>',{text: "Seleccionar", value: ""}));
        if(data.data.length>0){
            for(var i=0; i<=(data.data.length)-1; i++){
                var option_data = {};
                var subfields = data.data[i];
                $.each(subfields, function( index, value ) {
                    if(index=='name' || index=='name_es'){
                        option_data.text = value;
                    }else if(index=='id'){
                        option_data.value = value;
                    }else{
                        option_data['data-'+index] = value;
                    }
                });
                subselect.append($('<option>', option_data));
            }
        }
    })
    .done(function() {
        //console.log( "second success" );
    })
    .fail(function() {
        console.log( "error" );
    })
    .always(function() {
        console.log( "complete" );
    });
});

$('select[data-action="product_subfields"]').change(function() {
    var subselect = $(this);
    var multiple_index = 0;
    var is_multiple = false;
    if(subselect.data('multiple')==1){
        is_multiple = true;
        multiple_index = subselect.data('index');
    }
    var option = $(this).find('option:selected');
    var type = option.parent().data('type');
    $.each(option.data(), function(index, value){
        switch(index){
            case 'image':
                if(value!=""){
                    var img = $('.js-'+type+'_image');
                    img.attr('src',img.data('base_src')+value);
                }
                break;
            default:
                console.log("in default");
                var selector = 'input[name="'+type+'_'+index+'"]';
                if(is_multiple){
                    selector = 'input[name="'+type+'_'+index+'[]"][data-index="'+multiple_index+'"]';
                }

                $(selector).val(value);

                break;
        }
    });
});
